import { useMutation, useQueryClient } from '@tanstack/react-query';

import { IProductAnnouncementReactionType } from '../../interfaces/IProductAnnouncementReaction';
import api from '../../services/api';
import { PRODUCT_ANNOUNCEMENT_REACTIONS_QUERY_KEY } from './useProductAnnouncementReactions';

const deleteProductAnnouncementReaction = ({
  productAnnouncementId,
  reactionType
}: {
  productAnnouncementId: number;
  reactionType: IProductAnnouncementReactionType;
}) =>
  api.delete(`/api/frontend/product_announcements/${productAnnouncementId}/reactions`, {
    body: { reaction_type: reactionType }
  });

const useDeleteProductAnnouncementReaction = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteProductAnnouncementReaction,
    onSuccess: (result, variables) =>
      queryClient.setQueryData(
        [PRODUCT_ANNOUNCEMENT_REACTIONS_QUERY_KEY, variables.productAnnouncementId],
        () => result
      )
  });
};

export default useDeleteProductAnnouncementReaction;
